import React, { useEffect, useState } from "react";

import { Box, Button, Menu, useTheme } from "@mui/material";
import { DataGrid, esES } from "@mui/x-data-grid";

import { tokens } from "../../../../theme";
import { GetListCompanyUseCase } from "../../../domain/GetListCompanyUseCase";
import { MenuItem } from "react-pro-sidebar";
import { useNavigate } from "react-router-dom";

const tableStyle = (colors) => {
  return {
    "& .MuiDataGrid-root": {
      border: "none",
    },
    "& .MuiDataGrid-cell": {
      borderBottom: "none",
    },
    "& .name-column--cell": {
      color: colors.greenAccent[300],
    },
    "& .MuiDataGrid-columnHeaders": {
      backgroundColor: colors.blueAccent[700],
      borderBottom: "none",
    },
    "& .MuiDataGrid-virtualScroller": {
      backgroundColor: colors.primary[400],
    },
    "& .MuiDataGrid-footerContainer": {
      borderTop: "none",
      backgroundColor: colors.blueAccent[700],
    },
    "& .MuiCheckbox-root": {
      color: `${colors.greenAccent[200]} !important`,
    },
  };
};

const ListCompanyScreen = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const [dataCompany, setDataCompany] = useState([]);

  useEffect(() => {
    const getCompanyList = async () => {
      const resp = await GetListCompanyUseCase();
      if (resp.message === "success") {
        console.log(resp.data);
        setDataCompany(resp.data);
      } else {
        setDataCompany();
      }
    };

    getCompanyList();
  }, []);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const columns = [
    {
      headerName: "NOMBRE",
      field: "name",
      type: "text",
      headerAlign: "left",
      align: "left",
      width: 250,
    },
    {
      headerName: "DIRECCION",
      headerAlign: "left",
      field: "address",
      type: "text",
      width: 350,
    },
    {
      headerName: "",
      field: "actions",
      headerAlign: "center",
      width: 180,
      align: "center",
      renderCell: ({ row: { id } }) => {
        return (
          <div>
            <Button
              color="success"
              sx={{ background: "#ffff" }}
              onClick={handleClick}
            >
              OPCIONES
            </Button>
            <Menu
              id="menu-options"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
            >
              <MenuItem onClick={() => navigate(`/admin/list-admin`)}>
                <Button variant="contained">Administradores</Button>
              </MenuItem>
              <MenuItem
                onClick={() => {
                  console.log(id);
                  navigate(`/admin/company/permisos/${id}`);
                }}
              >
                <Button variant="contained" fullWidth>
                  PERMISOS
                </Button>
              </MenuItem>
              <MenuItem onClick={handleClose}>...</MenuItem>
            </Menu>
          </div>
        );
      },
    },
  ];

  return (
    <Box m="10px 0 0 0" height="100vh" sx={tableStyle(colors)}>
      <DataGrid
        getRowId={(row) => row.id}
        rows={dataCompany}
        columns={columns}
        localeText={esES.components.MuiDataGrid.defaultProps.localeText}
      />
    </Box>
  );
};

export default ListCompanyScreen;
